import Vue from 'vue'
import Vuex from 'vuex'
import ticket from "./ticket"
Vue.use(Vuex)

export default new Vuex.Store({
  //  状态机里面的数据写死一次 后续银联支付完成后 会重定向回来一次 得确保有上一次数据能先行调用
  state: {
    hasTabbar: false,
    barActive: null,
    //  是否获取到 token
    isReadyOk: false,
    userInfo:{
      userId: sessionStorage.getItem('temp-set-user-id') || '123',
      // userId: '53bf16892cfa4a2295b7f7c229f3493e',
      openId: sessionStorage.getItem('temp-set-open-id') || 'HSBCZHBXHSCXSSDFG',
      isBind: JSON.parse( sessionStorage.getItem('temp-set-is-bind-info') ) || false,//..反应当前用户是否绑定信息 从而控制页面的跳转和在个人中心页面刷新的时候的拦截问题
      info: JSON.parse( sessionStorage.getItem('temp-set-user-detail-info') ) || {},
    },
    ...ticket,
    shoppingBlock: {
      // bgImgPrefix: 'http://124.161.16.164:11080/',
      bgImgPrefix: window._bgImgPrefix,
      // bgImgPrefix: 'http://www.daxi51.com/',
      shopCar: new Map(),
    },
    //  页面跳转的临时传递参数对象
    tempTransmitParams: sessionStorage.getItem('temp-transmit-params') ? JSON.parse(sessionStorage.getItem('temp-transmit-params')) : {}
  },
  mutations: {
    setTabbar(state, isShow = false) {
      state.hasTabbar = isShow
    },
    setBarActive (state, index = null) {
      state.barActive = index
    },
    setParmas(state, parasm = {}) {
      sessionStorage.setItem('temp-transmit-params', JSON.stringify(parasm))
      state.tempTransmitParams = parasm
    },
    addToShopCar(state, product = {}) {
      state.shoppingBlock.shopCar.set(product.skuId, product);
    },
    setShopCar(state) {
      state.shoppingBlock.shopCar = new Map()
    },
    setIsReadyOk (state, flag = false) {
      state.isReadyOk = flag;
    },
    setOpenId (state, openId = "") {
      state.userInfo.openId = openId;
      sessionStorage.setItem('temp-set-open-id', openId)
    },
    setUserId (state, userId = "") {
      state.userInfo.userId = userId;
      sessionStorage.setItem('temp-set-user-id', userId)
    },
    setUserInnerInfo (state, info = {}) {
      state.userInfo.info = info;
      sessionStorage.setItem('temp-set-user-detail-info', JSON.stringify(info))
    },
    setIsBind (state, flag = false) {
      state.userInfo.isBind = flag;
      sessionStorage.setItem('temp-set-is-bind-info', JSON.stringify(flag))
    },
  },
  getters: {
    getShopCar(state) {
      return state.shoppingBlock.shopCar
    }
  },
  actions: {
  },
  modules: {
  }
})



